// extracted by mini-css-extract-plugin
export default {"recos":"C1-z","productCardOverride":"D1-z","rowHasBadge":"E1-z"};